export function getResourceFromS3(path: string, nomeArquivo: string, host?: string) {
    const baseHost = host?.replace(/\/+$/, '') || 'https://public-resources.cdn.magazord.com.br'
    const normalizedPath = path.replace(/^\/+|\/+$/g, '') // remove / no início e no fim

    return `${baseHost}/${normalizedPath}/${nomeArquivo}`
}

